var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.04,62.47c-.11,0-.23,0-.35-.03-1.16-.18-1.94-1.19-1.76-2.27L19.88,3.68c.19-1.08,1.29-1.81,2.44-1.63,1.16,.18,1.94,1.19,1.76,2.27L14.14,60.81c-.17,.97-1.07,1.66-2.1,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.05,62.5c-1.02,0-1.93-.69-2.1-1.66L40.04,4.34c-.19-1.08,.6-2.09,1.76-2.27,1.15-.18,2.25,.55,2.44,1.63l9.91,56.5c.19,1.08-.6,2.09-1.76,2.27-.12,.02-.23,.03-.34,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,61.97c-1.17,0-2.13-.88-2.13-1.97v-8.14c0-1.09,.95-1.97,2.13-1.97s2.13,.88,2.13,1.97v8.14c0,1.09-.95,1.97-2.13,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.06,45.47c-1.17,0-2.13-.88-2.13-1.97v-8.14c0-1.09,.95-1.97,2.13-1.97s2.13,.88,2.13,1.97v8.14c0,1.09-.95,1.97-2.13,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,30.23c-1.17,0-2.13-.88-2.13-1.97v-8.14c0-1.09,.95-1.97,2.13-1.97s2.13,.88,2.13,1.97v8.14c0,1.09-.95,1.97-2.13,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.06,14.99c-1.17,0-2.13-.88-2.13-1.97V4.88c0-1.09,.95-1.97,2.13-1.97s2.13,.88,2.13,1.97V13.01c0,1.09-.95,1.97-2.13,1.97Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoRoute);
export default __webpack_public_path__ + "static/media/pho_route.7e57a7054eb9c849e2098171465ba62e.svg";
export { ForwardRef as ReactComponent };